import { defineMessages } from 'react-intl';

export const membershipMessages = defineMessages({
    memberships: {
        id: 'memberships',
        defaultMessage: 'Memberships',
    },
    all: {
        id: 'memberships-all',
        defaultMessage: 'All',
    },
    membership: {
        id: 'membership',
        defaultMessage: 'Membership',
    },
    // Dedicated membership ids so BG can use the neuter forms "Активно от/до" (членство), unlike the
    // shared `active-from`/`active-to` keys which are masculine ("Активен") for pricing plans/access keys.
    activeFrom: {
        id: 'membership-active-from',
        defaultMessage: 'Active from',
    },
    activeTo: {
        id: 'membership-active-to',
        defaultMessage: 'Active to',
    },
    monday: {
        id: 'monday',
        defaultMessage: 'Monday',
    },
    tuesday: {
        id: 'tuesday',
        defaultMessage: 'Tuesday',
    },
    wednesday: {
        id: 'wednesday',
        defaultMessage: 'Wednesday',
    },
    thursday: {
        id: 'thursday',
        defaultMessage: 'Thursday',
    },
    friday: {
        id: 'friday',
        defaultMessage: 'Friday',
    },
    saturday: {
        id: 'saturday',
        defaultMessage: 'Saturday',
    },
    sunday: {
        id: 'sunday',
        defaultMessage: 'Sunday',
    },
    notAllowed: {
        id: 'not-allowed',
        defaultMessage: 'Not allowed',
    },
    allowedDays: {
        id: 'allowed-days',
        defaultMessage: 'Allowed days',
    },
    isActive: {
        id: 'active',
        defaultMessage: 'Is active',
    },
    // Dedicated "Active" label for the memberships table — BG needs the neuter form "Активно"
    // (членство), unlike the shared `active` key which is masculine ("Активен") for users/types.
    membershipActive: {
        id: 'membership-active',
        defaultMessage: 'Active',
    },
    allowedSpaces: {
        id: 'allowed-spaces',
        defaultMessage: 'Allowed spaces',
    },
    identifiers: {
        id: 'identifiers',
        defaultMessage: 'Identifiers',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    template: {
        id: 'template',
        defaultMessage: 'Template',
    },
    inParking: {
        id: 'in-parking',
        defaultMessage: 'In parking',
    },
    notInParking: {
        id: 'not-in-parking',
        defaultMessage: 'Not in parking',
    },
    maxAllowedSpaces: {
        id: 'max-allowed-spaces',
        defaultMessage: 'Max allowed spaces',
    },
    maxExtraVisitors: {
        id: 'max-extra-visitors',
        defaultMessage: 'Max extra visitors',
    },
    // Dedicated membership ids so BG can use the neuter forms "Валидно от/до" (членство), unlike the
    // shared `valid-from`/`valid-to` keys which are masculine ("Валиден") for pricing plans/access keys.
    validFrom: {
        id: 'membership-valid-from',
        defaultMessage: 'Valid from',
    },
    validTo: {
        id: 'membership-valid-to',
        defaultMessage: 'Valid to',
    },
    identifierCount: {
        id: 'identifier-count',
        defaultMessage: '{count, plural, one {# identifier} other {# identifiers}}',
    },
    owner: {
        id: 'owner',
        defaultMessage: 'Owner',
    },
    pricedPerSpace: {
        id: 'priced-per-space',
        defaultMessage: 'Priced per space',
    },
    autoRenew: {
        id: 'auto-renew',
        defaultMessage: 'Auto renew',
    },
    limitDuration: {
        id: 'limit-duration',
        defaultMessage: 'Limit duration',
    },
    accessOverCapacityLimit: {
        id: 'access-over-capacity-limit',
        defaultMessage: 'Access over capacity limit',
    },
    accessClientOverRestriction: {
        id: 'access-client-over-restriction',
        defaultMessage: 'Allow access as client over restriction',
    },
    addMembershipSubtitle: {
        id: 'add-membership-subtitle',
        defaultMessage: 'Add new membership',
    },
    createMembershipSuccessDescription: {
        id: 'create-membership-success-description',
        defaultMessage: 'Membership {entry} has been successfully created.',
    },
    createMembershipSuccess: {
        id: 'create-membership-success',
        defaultMessage: 'Membership created',
    },
    updateMembershipSuccess: {
        id: 'update-membership-success',
        defaultMessage: 'Membership updated',
    },
    updateMembershipSuccessDescription: {
        id: 'update-membership-success-description',
        defaultMessage: 'Membership {entry} has been successfully updated.',
    },
    editMembershipSubtitle: {
        id: 'edit-membership-subtitle',
        defaultMessage: 'Edit membership {entry}',
    },
    membershipDashboard: {
        id: 'membership-dashboard',
        defaultMessage: 'Membership dashboard',
    },
    deleteMembershipSuccess: {
        id: 'delete-membership-success',
        defaultMessage: 'Membership deleted',
    },
    deleteMembershipSuccessDescription: {
        id: 'delete-membership-success-description',
        defaultMessage: 'Membership {entry} has been successfully deleted.',
    },
    deleteMembershipSubtitle: {
        id: 'delete-membership-subtitle',
        defaultMessage: 'Permanently delete membership {entry}',
    },
    confirmDeleteMembership: {
        id: 'confirm-delete-membership',
        defaultMessage: 'Are you sure you want to delete membership {entry}? This action cannot be undone.',
    },
    members: {
        id: 'members',
        defaultMessage: 'Members',
    },
    configuration: {
        id: 'configuration',
        defaultMessage: 'Configuration',
    },
    gatewayPasses: {
        id: 'gateway-passes',
        defaultMessage: 'Gateway passes',
    },
    pastStays: {
        id: 'past-stays',
        defaultMessage: 'Past stays',
    },
    payments: {
        id: 'payments',
        defaultMessage: 'Payments',
    },
    accessKey: {
        id: 'access-key',
        defaultMessage: 'Access key',
    },
    ticket: {
        id: 'ticket',
        defaultMessage: 'Ticket',
    },
    licensePlate: {
        id: 'license-plate',
        defaultMessage: 'License plate',
    },
    duration: {
        id: 'duration',
        defaultMessage: 'Duration',
    },
    customDuration: {
        id: 'custom-duration',
        defaultMessage: 'Custom duration',
    },
    entity: {
        id: 'entity',
        defaultMessage: 'Entity',
    },
    phone: {
        id: 'phone',
        defaultMessage: 'Phone',
    },
    email: {
        id: 'email',
        defaultMessage: 'Email',
    },
    description: {
        id: 'description',
        defaultMessage: 'Description',
    },
    person: {
        id: 'person',
        defaultMessage: 'Person',
    },
    organisation: {
        id: 'organisation',
        defaultMessage: 'Organisation',
    },
    searchEntity: {
        id: 'search-entity',
        defaultMessage: 'Search for entity',
    },
    createEntity: {
        id: 'create-entity',
        defaultMessage: 'Create entity',
    },
    noEntities: {
        id: 'no-entities',
        defaultMessage: 'No entities',
    },
    noEntitiesFound: {
        id: 'no-entities-found',
        defaultMessage: 'No entities found',
    },
    clearSelection: {
        id: 'clear-selection',
        defaultMessage: 'Clear selection',
    },
    site: {
        id: 'site',
        defaultMessage: 'Site',
    },
    pricingPlan: {
        id: 'pricing-plan',
        defaultMessage: 'Pricing plan',
    },
    activePeriod: {
        id: 'active-period',
        defaultMessage: 'Active period',
    },
    ref: {
        id: 'ref',
        defaultMessage: 'Ref',
    },
    inactiveMembershipTypeError: {
        id: 'custom-error:membership_type_inactive',
        defaultMessage: 'The membership type is inactive!',
    },
    createdAt: {
        id: 'created-at',
        defaultMessage: 'Created at',
    },
    modifiedAt: {
        id: 'modified-at',
        defaultMessage: 'Modified at',
    },
});

export const identifiersMessages = defineMessages({
    addIdentifierSubtitle: {
        id: 'add-identifier-subtitle',
        defaultMessage: 'Add new identifier',
    },
    createIdentifierSuccessDescription: {
        id: 'create-identifier-success-description',
        defaultMessage: 'Identifier {entry} has been successfully created.',
    },
    createIdentifierSuccess: {
        id: 'create-identifier-success',
        defaultMessage: 'Identifier created',
    },
    updateIdentifierSuccess: {
        id: 'update-identifier-success',
        defaultMessage: 'Identifier updated',
    },
    updateIdentifierSuccessDescription: {
        id: 'update-identifier-success-description',
        defaultMessage: 'Identifier {entry} has been successfully updated.',
    },
    editIdentifierSubtitle: {
        id: 'edit-identifier-subtitle',
        defaultMessage: 'Edit identifier {entry}',
    },
    identifierDashboard: {
        id: 'identifier-dashboard',
        defaultMessage: 'Identifier dashboard',
    },
    deleteIdentifierSuccess: {
        id: 'delete-identifier-success',
        defaultMessage: 'Identifier deleted',
    },
    deleteIdentifierSuccessDescription: {
        id: 'delete-identifier-success-description',
        defaultMessage: 'Identifier {entry} has been successfully deleted.',
    },
    deleteIdentifierSubtitle: {
        id: 'delete-identifier-subtitle',
        defaultMessage: 'Permanently delete identifier {entry}',
    },
    confirmDeleteIdentifier: {
        id: 'confirm-delete-identifier',
        defaultMessage: 'Are you sure you want to delete identifier {entry}? This action cannot be undone.',
    },
    identifier: {
        id: 'identifier',
        defaultMessage: 'Identifier',
    },
    identifiers: {
        id: 'identifiers',
        defaultMessage: 'Identifiers',
    },
    privateNotes: {
        id: 'private-notes',
        defaultMessage: 'Private notes',
    },
    publicNotes: {
        id: 'public-notes',
        defaultMessage: 'Public notes',
    },
    owner: {
        id: 'owner',
        defaultMessage: 'Owner',
    },
    licensePlate: {
        id: 'license-plate',
        defaultMessage: 'License plate',
    },
    accessKey: {
        id: 'access-key',
        defaultMessage: 'Access key',
    },
    identifierType: {
        id: 'identifier-type',
        defaultMessage: 'Identifier type',
    },
    activeStay: {
        id: 'active-stay',
        defaultMessage: 'Active stay',
    },
    validationErrorLicensePlateFormat: {
        id: 'validation-error-license-plate-format',
        defaultMessage: 'Invalid license plate format',
    },
    notes: {
        id: 'notes',
        defaultMessage: 'Notes',
    },
    invalidConfiguration: {
        id: 'invalid-configuration',
        defaultMessage: 'Invalid configuration',
    },
});
